/**
 * Canonical route paths for the predictions module.
 *
 * `PREDICTIONS_NOTIFICATIONS_ROUTE` and `PREDICTIONS_LIVE_EVENTS_ROUTE` are not
 * decoration: together they are the gate the app-wide sound mount reads to
 * decide whether this tab is allowed to ring (see `PredictionNotificationSound`
 * and {@link isSoundRoute}). The live feed used to be a tab INSIDE the
 * notifications page, so an operator watching it heard the fill and naked-leg
 * alarms; it now has its own route, and it must keep ringing them. The sidebar
 * nav entries and the sound gate MUST agree on the literals, so they live here
 * instead of being typed twice — a drift between them would look like "the
 * sound just stopped working" with nothing broken in either file on its own.
 */
export const PREDICTIONS_NOTIFICATIONS_ROUTE = '/predictions/notifications';

export const PREDICTIONS_LIVE_EVENTS_ROUTE = '/predictions/live-events';

/**
 * `pathname` with the trailing slash normalised away. React Router renders a
 * page for `/predictions/notifications/` just the same, but `location.pathname`
 * keeps the slash — a raw `===` would then look at a tab showing the feed and
 * decide it is not the feed, going silent with nothing on screen to explain
 * it. Reachable from a bookmark, a typed URL or a CDN normalisation.
 */
function normalisePath(pathname: string): string {
  return pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;
}

/** Is `pathname` a page the notification sounds ring on — the notifications
 *  feed or the Live events screen? */
export function isSoundRoute(pathname: string): boolean {
  const normalised = normalisePath(pathname);
  return (
    normalised === PREDICTIONS_NOTIFICATIONS_ROUTE ||
    normalised === PREDICTIONS_LIVE_EVENTS_ROUTE
  );
}
